import { render } from "./CalendarCard.vue?vue&type=template&id=2acc4555"
import script from "./CalendarCard.vue?vue&type=script&lang=js"
export * from "./CalendarCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__